import { createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-sm text-black-lp-300"
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" This site is protected by reCAPTCHA and the Google ")
const _hoisted_3 = /*#__PURE__*/_createVNode("a", {
  href: "https://policies.google.com/privacy",
  target: "_blank",
  class: "text-blue-lp-800"
}, " Privacy Policy ", -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" and ")
const _hoisted_5 = /*#__PURE__*/_createVNode("a", {
  href: "https://policies.google.com/terms",
  target: "_blank",
  class: "text-blue-lp-800"
}, " Term of Service ", -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" apply. ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.show)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        _hoisted_4,
        _hoisted_5,
        _hoisted_6
      ]))
    : _createCommentVNode("", true)
}